<template>
  <section id="Coupon" class="bg-white">
    <div class="card w-100 rounded-0 border-0">
      <div
        v-if="coupon.media"
        v-lazy:background-image="coupon.media.data.length>0 ? coupon.media.data[0].original : ''"
        class="card-img-top"
      >
        <div
          v-if="coupon.brand_thumb"
          class="brand"
          v-lazy:background-image="coupon.brand_thumb"
        ></div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-8">
            <h1 class="h3 card-title text-primary-light">{{coupon.title}}</h1>
            <p class="card-text">{{coupon.subtitle}}</p>
            <p class="text-secondary-light">{{coupon.content}}</p>
          </div>
          <div
            class="col-md-4 d-block d-md-flex flex-column align-items-end justify-content-between"
          >
            <div class="price d-flex align-items-center">
              <Icons name="product" color="#eec273" :width="35" :height="35"></Icons>
              <span class="h3 mb-0 ml-10">{{ coupon.point | currency }}</span>
            </div>
            <p class="text-secondary-light">
              <small>
                <span class="d-md-none d-lg-inline">有效期限</span>
                {{coupon.expire_at | date}}
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="desc mt-30">
      <ul class="pl-15">
        <li v-for="(item, index) in rules" :key="index">
          <p>{{item}}</p>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import Icons from '@/components/icon.vue';

export default {
  name: 'Coupon',
  components: {
    Icons,
  },
  data() {
    return {
      coupon: {},
    };
  },
  computed: {
    rules() {
      return this.coupon.content ? this.coupon.content.split('\n') : '';
    },
  },
  methods: {
    getCoupon() {
      const url = `/coupon/${this.$route.params.id}`;
      this.axios
        .get(url)
        .then((response) => {
          const coupon = response.data.data[0];
          this.coupon = coupon;
          this.$emit('sendTitle', this.coupon.title);
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
          if (error.response.data.code) {
            this.$router.go(-1);
          }
        });
    },
  },
  mounted() {
    this.getCoupon();
  },
};
</script>
<style lang="scss" scoped>
#Coupon {
  padding: 20px 0 100px;
  .card-img-top {
    min-height: 500px;
    background-color: $primary;
    background-size: auto 350px;
    background-position: top center;
    background-repeat: no-repeat;
    position: relative;
    @media (min-width: 768px) {
      background-size: cover;
      background-position: center center;
    }
    .brand {
      position: absolute;
      bottom: 50px;
      left: calc(50% - 75px);
      width: 150px;
      height: 150px;
      box-shadow: rgba(0, 0, 0, 0.1) 0px  0px 10px 2px;
      border-radius: 10px;
      background-color: #fff;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      @media (min-width: 768px) {
        top: 100px;
        left: 75px;
      }
    }
  }
  .card-body {
    background-image: url('~@/assets/image/card-bg.png');
    background-size: cover;
    .row {
      & > div:first-child {
        @media (min-width: 768px) {
          border-right: 1px dashed #000;
        }
      }
      & > div:last-child {
        margin-top: 20px;
        @media (min-width: 768px) {
          margin-top: 0;
        }
        .price {
          justify-content: start;
          @media (min-width: 768px) {
            justify-content: end;
          }
        }
        p {
          @media (min-width: 768px) {
            text-align: right;
          }
        }
      }
    }
    svg {
      background-color: #fff;
      border-radius: 50%;
    }
  }
}
</style>
